import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/welcome.css';
import { LOGO_URL } from '../config/assets';

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/landing', { replace: true });
    }, 5000); // keep your 5s auto-redirect
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="welcome-wrap">
      <div className="logo-container">
        <img
          src={LOGO_URL}
          alt="Thomas Y. Pickett Logo"
          className="logo-elegant"
          decoding="async"
        />

        <div className="company-divider" aria-hidden="true"></div>

        <p className="company-tagline">Industrial &amp; Mineral Appraisal Service </p>
        <p className="company-tagline">Since 1926 </p>

        <div className="loading-container" aria-hidden="true">
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
